import React from 'react'

export default function Intro() {
  return (
    <>
      <section className=" intro w-50 mx-auto text-center pt-5 intro">
        <h1 id="servicio" className="p-3 fs-2 border-top border-3">
          La Mejor alternativa para tu Vehiculo de{" "}
          <span className="colorsito">GAS PROPANO</span>
        </h1>
        <p className="pt-1 fs-5">
          Mejora el rendimiento de tu Vehiculo con un sistema de gas
          <span className="colorsito"> profesional</span>
        </p>
      </section>
    </>
  );
}
